'use strict';
var utils = require('lyonscg/util/utils');
var imagesPerRow = $('#category-tiles-per-row').data('category-items') || 6;
var imagesPerRowMobile = $('#category-tiles-per-row').data('category-items-mobile') || 3;
var imageslideDesktop = $('.thumb-section').data('slide');
var imageslideMobile = $('.thumb-section').data('count');

/**
 * Reusable slick carousel configurations
 * @example - $('.product-carousel').slick(slickConfigs.pdp)
 */

module.exports = {
    hero: {
        autoplay: true,
        autoplaySpeed: 5000,
        easing: 'swing',
        infinite: true,
        speed: 800,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: '.hero-slider-custom-navigation .slick-dots-custom',
        prevArrow: $('.hero-slider-custom-navigation .slick-arrows-custom-prev'),
        nextArrow: $('.hero-slider-custom-navigation .slick-arrows-custom-next')
    },

    categorySubFolderTiles: {
        infinite: false,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: imagesPerRow,
        slidesToScroll: 1,
        appendDots: '.category-subfolder-tile-caro-arrows .slick-dots-custom',
        prevArrow: $('.category-subfolder-tile-caro-arrows .slick-arrows-custom-prev'),
        nextArrow: $('.category-subfolder-tile-caro-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: imagesPerRow,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: imagesPerRow - 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: imagesPerRowMobile,
                    slidesToScroll: 1
                }
            }
        ]
    },

    productTiles: {
        infinite: false,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendDots: $('.product-carousel-arrows .slick-dots-custom'),
        prevArrow: $('.product-carousel-arrows .slick-arrows-custom-prev'),
        nextArrow: $('.product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    },

    productRecommendationTile: {
        infinite: false,
        speed: 300,
        dots: true,
        arrows: true,
        variableWidth: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        appendDots: $('.product-carousel-arrows .slick-dots-custom'),
        prevArrow: $('.product-carousel-arrows .slick-arrows-custom-prev'),
        nextArrow: $('.product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    },

    productGiroRecommendationTile: {
        infinite: false,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendDots: $('.product-carousel-arrows .slick-dots-custom'),
        prevArrow: $('.product-carousel-arrows .slick-arrows-custom-prev'),
        nextArrow: $('.product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    },


    // one tile on mobile for product carousel
    productTilesHeroMobile: {
        infinite: false,
        speed: 300,
        dots: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendDots: $('.landing-page .product-carousel-arrows .slick-dots-custom'),
        prevArrow: $('.landing-page .product-carousel-arrows .slick-arrows-custom-pre'),
        nextArrow: $('.landing-page .product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    },

    QuickViewHorizontalSlick: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        focusOnSelect: true,
        accessibility: false,
        asNavFor: '.primary-images .pdp-slideCarousel'
    },

    pdpHorizontalSlick: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: imageslideDesktop,
        slidesToScroll: 1,
        centerMode: false,
        focusOnSelect: true,
        accessibility: false,
        asNavFor: '.primary-images .pdp-slideCarousel',
        responsive: [
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: imageslideMobile,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    },

    pdpSlick: {
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        asNavFor: '.primary-images .scrollThumb'
    },

    // pdp: {
    //     infinite: true,
    //     speed: 400,
    //     dots: true,
    //     arrows: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     variableWidth: true,
    //     centerMode: false,
    //     appendDots: '.primary-images .product-carousel-arrows .slick-dots-custom',
    //     prevArrow: $('.primary-images .product-carousel-arrows .slick-arrows-custom-prev'),
    //     nextArrow: $('.primary-images .product-carousel-arrows .slick-arrows-custom-next')
    // },

    bonusModal: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    },

    quickView: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: '.quick-view-dialog .product-carousel-arrows .slick-dots-custom'
    },

    video: {
        speed: 400,
        infinite: false,
        dots: true,
        arrows: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: '.pdp-videos .product-carousel-arrows .slick-dots-custom',
        prevArrow: $('.pdp-videos .product-carousel-arrows .slick-arrows-custom-prev'),
        nextArrow: $('.pdp-videos .product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    },

    tech: {
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: '.tech-slide',
        mobileFirst: true,
        appendDots: '#technology .product-carousel-arrows .slick-dots-custom',
        prevArrow: $('#technology .product-carousel-arrows .slick-arrows-custom-prev'),
        nextArrow: $('#technology .product-carousel-arrows .slick-arrows-custom-next'),
        responsive: [
            {
                breakpoint: utils.getViewports('lg'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('md'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: utils.getViewports('sm'),
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    },
    reinitPagination: function (event, slick, defaultSlidesToShow) {
        if (slick.length === 0) {
            return;
        }
        var breakpoints = slick.breakpointSettings;
        var currentBreakpoint = slick.activeBreakpoint;
        var slidesToShow = defaultSlidesToShow; // default slides count (desktop) // 4 for product carousel and articles
        if (currentBreakpoint || slick.options.mobileFirst) { // allow for mobileFirst configs (xs is not active)
            slidesToShow = currentBreakpoint ? breakpoints[currentBreakpoint].slidesToShow : slick.options.slidesToShow;
            if (slick.slideCount <= slidesToShow) {
                slick.$dots.hide();
                slick.$nextArrow.hide();
                slick.$prevArrow.hide();
            } else {
                slick.$dots.show();
                slick.$nextArrow.show();
                slick.$prevArrow.show();
            }
        } else if (slick.slideCount <= slidesToShow) {
            slick.$dots.hide();
            slick.$nextArrow.hide();
            slick.$prevArrow.hide();
        } else {
            slick.$dots.show();
            slick.$nextArrow.show();
            slick.$prevArrow.show();
        }
    }
};
